import { useState, useEffect } from "react";

import { Link as RouterLink } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Link, Typography, Box } from "@mui/material";
// components
import Page from "../components/Page";
import { LoginForm } from "../components/authentication/login";
import Logo from "src/components/Logo";
// import StationPNG from "../image/stations.png";
// import Car from "../image/car.png";
// import ChargerIcon1 from "../image/charger-icon-1.png";
// import ChargerIcon2 from "../image/charger-icon-2.png";
// import ChargerIcon3 from "../image/charger-icon-3.png";
// import ChargerIcon4 from "../image/charger-icon-4.png";
import "./pages.css";
// ----------------------------------------------------------------------

const LOGIN_BASE_GRADIENT = "linear-gradient(140deg, #f8fcff 0%, #f4f1ff 55%, #fff6ff 100%)";
const LOGIN_ACCENT_GRADIENT = "linear-gradient(120deg, rgba(75, 211, 255, 0.25) 0%, rgba(138, 92, 255, 0.22) 65%, rgba(255, 255, 255, 0.35) 100%)";

const RootStyle = styled(Page)(({ theme }) => ({
  position: "relative",
  minHeight: "100vh",
  overflow: "visible",
  backgroundColor: "#f6f7ff",
  backgroundImage: LOGIN_BASE_GRADIENT,
  color: "#111a3c",
  "&::before": {
    content: "''",
    position: "absolute",
    inset: 0,
    backgroundImage: LOGIN_ACCENT_GRADIENT,
    opacity: 0.7,
    pointerEvents: "none",
  },
  "& > *": {
    position: "relative",
    zIndex: 1,
  },
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const [error, setError] = useState(null);
  useEffect(() => {
    const redirectedURL = new URLSearchParams(window.location.search);
    const loginStatus = redirectedURL.get("emailVerificationStatus");
    switch (loginStatus) {
      case "alreadyVerified":
        setError("Email is already verified, Please login.");
        break;
      case "false":
        setError("Email verification failed, Please try again or contact us.");
        break;
      default:
        //  Token.get() && (window.location.href = enums.path.DASHBOARD_APP);
        break;
    }
  }, []);

  return (
    <RootStyle title="Login | Smart-CMS">
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          minHeight: "100vh",
          overflow: "visible",
          background: "transparent",
        }}
      >
        <Box
          className="container"
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "100%", md: "100%" },
            placeItems: "center",
            minHeight: "100vh",
            padding: { xs: "40px 16px", md: "60px 32px" },
            background: "transparent",
          }}
        >
          <Box
            className="form_container"
            sx={{
              width: "33.3%",
              backgroundColor: "rgba(255, 255, 255, 0.96)",
              padding: "32px 28px 40px",
              borderRadius: "15px",
              minHeight: "85vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "25px",
              border: "1px solid rgba(75, 211, 255, 0.25)",
              boxShadow: "0 30px 70px rgba(34, 45, 90, 0.12)",
              backdropFilter: "blur(8px)",
              color: "#111a3c",
            }}
          >
            <Stack sx={{ mb: 4 }} direction="column" alignItems="center">
              <Typography
                className="header_signin"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  fontSize: "26px",
                  fontWeight: 600,
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Logo
                  width="100%"
                  sx={{
                    fontSize: { xs: "1.35rem", md: "2rem" },
                    fontWeight: 800,
                    lineHeight: 1.2,
                  }}
                />
              </Typography>
              <Typography sx={{ fontSize: "26px", fontWeight: 600, color: "#1f2655" }}>
                Welcome back
              </Typography>
              <Typography sx={{ color: "#6b7088", fontSize: "15px" }}>
                Please enter your login details.
              </Typography>
            </Stack>
            <LoginForm />
              <Stack direction="row" spacing={0.5} justifyContent="center" sx={{ mt: 2 }}>
              <Typography sx={{ fontSize: "14px", color: "#6b7088" }}>
                Don&apos;t have an account?
              </Typography>
              <Link
                component={RouterLink}
                to="/signup"
                sx={{ fontSize: "14px", fontWeight: 600, color: "#8a5cff", textDecoration: "none" }}
              >
                Signup
              </Link>
            </Stack>
          </Box>
          {/* <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: "auto", md: "100%" },
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box>
              <img src={ChargerIcon1} className="charger-flow" alt="Smart Smart EV" />
              <img src={ChargerIcon2} className="charger-flow" alt="Smart Smart EV" />
              <img src={ChargerIcon3} className="charger-flow" alt="Smart Smart EV" />
              <img src={ChargerIcon4} className="charger-flow" alt="Smart Smart EV" />
              <img className="car-3d" src={Car} alt="Smart Smart EV" />
              <img className="grid-3d" width="324" height="426" src={StationPNG} alt="Smart Smart EV" />
            </Box>
            <Box>
              <div className="gradient-green-blur-md"></div>
            </Box>
          </Box> */}
        </Box>
      </Box>
    </RootStyle>
  );
}
